import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_updateAllPatientConditionsInput,
  chUpdateAllPatientConditionsMutation,
  chUpdateAllPatientConditionsMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdateAllPatientConditionsMutation.graphql"
import { chUpdateAllPatientConditionsMutation as chMutation } from "@/modules/patients/services/ch/chUpdateAllPatientConditionsMutation"
import {
  De_updateAllPatientConditionsInput,
  deUpdateAllPatientConditionsMutation,
  deUpdateAllPatientConditionsMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdateAllPatientConditionsMutation.graphql"
import { deUpdateAllPatientConditionsMutation as deMutation } from "@/modules/patients/services/de/deUpdateAllPatientConditionsMutation"

const useUpdateAllPatientConditionsMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<
    chUpdateAllPatientConditionsMutation & deUpdateAllPatientConditionsMutation
  >(mutation)

  return useCallback(
    (
      input: De_updateAllPatientConditionsInput & Ch_updateAllPatientConditionsInput,
      onCompleted?: (
        res: chUpdateAllPatientConditionsMutation$data & deUpdateAllPatientConditionsMutation$data,
      ) => void,
      onError?: (res: chUpdateAllPatientConditionsMutation$data & deUpdateAllPatientConditionsMutation$data) => void,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.updateAllPatientConditions
          if (!data.errors?.length) {
            onCompleted?.(response)
          } else {
            onError?.(response)
          }
        },
      })
    },
    [commit],
  )
}

export { useUpdateAllPatientConditionsMutation }
